module.exports = __webpack_public_path__ + "img/PXL_20230524_183128142.72c7c487.jpg";